import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { KRollService } from 'src/app/core/services/api-services/kroll.service';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-update-order-rxids',
  templateUrl: './update-order-rxids.component.html',
  styleUrls: ['./update-order-rxids.component.scss']
})
export class UpdateOrderRxidsComponent {
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  disableButton: boolean = false;
  users: any[] = [];
  filteredUsers: any[] = [];
  allSelected: boolean = false;
  selectedFilter: string = 'all';  // Default to show all users
  addressList: any[] = [];
  show_address_popup: any;

  constructor(
    public dialogRef: MatDialogRef<UpdateOrderRxidsComponent>,
    private fb: FormBuilder,
    public krollService: KRollService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any,
    public toast: ToastrService,
    public dialog: MatDialog,
  ) {
    this.initializeForm();
    this.applyFilter();  // Apply filter after initialization
  }

  initializeForm() {
    if (!Array.isArray(this.props.item)) {
      console.error('Invalid item format: expected array');
      return;
    }
    const [krollDataObj, addressListArr, showPopupFlag] = this.props.item;
    const krollData = (krollDataObj && typeof krollDataObj == 'object' && !Array.isArray(krollDataObj)) ? krollDataObj : {};
    this.addressList = Array.isArray(addressListArr) ? addressListArr : [];
    this.show_address_popup = !!showPopupFlag;
    // Convert krollData to user list
    this.users = Object.values(krollData);
    this.filteredUsers = this.users;
    this.users.forEach(user => {
      this.form.addControl(
        `krollId_${user.userId}`,
        new FormControl(user.new_kroll_id, [Validators.required])
      );
      this.form.addControl(
        `selected_${user.userId}`,
        new FormControl(false)
      );
    });
  }

  selectAll(event: any) {
    const checked = event.checked;
    this.allSelected = checked;
    this.filteredUsers.forEach(user => {
      const control = this.form.get(`selected_${user.userId}`);
      if (control) {
        control.setValue(checked);
      }
    });
  }

  updateSelectAllState() {
    this.allSelected = this.filteredUsers.every(user => this.form.get(`selected_${user.userId}`)?.value);
  }

  isAnyUserSelected(): boolean {
    return this.filteredUsers.some(user => this.form.get(`selected_${user.userId}`)?.value);
  }

  getActionButtonLabel(): string {
    const hasIdNotAssigned = this.filteredUsers.some(user => this.form.get(`selected_${user.userId}`)?.value && user.old_kroll_id === 0);
    const hasKrollIdMismatch = this.filteredUsers.some(user => this.form.get(`selected_${user.userId}`)?.value && user.old_kroll_id !== 0);

    if (hasIdNotAssigned && hasKrollIdMismatch) {
      return 'Update & Confirm';
    } else if (hasIdNotAssigned) {
      return 'Update';
    } else if (hasKrollIdMismatch) {
      return 'Confirm';
    }
    return 'Update';  // Default button text
  }

  applyFilter() {
    if (this.selectedFilter === 'mismatch') {
      this.filteredUsers = this.users.filter(user => user.old_kroll_id !== 0);
    } else if (this.selectedFilter === 'notAssigned') {
      this.filteredUsers = this.users.filter(user => user.old_kroll_id === 0);
    } else {
      this.filteredUsers = this.users;  // Show all users
    }
  }

  formSubmit() {
    if (this.form.valid) {
      const _filteredUsers = cloneDeep(this.filteredUsers);
      const payload = _filteredUsers
        .filter(user => this.form.get(`selected_${user.userId}`)?.value)
        .reduce((acc, user) => {
          acc[user.userId] = {
            userId: user.userId,
            email: user.email,
            old_kroll_id: user.old_kroll_id,
            new_kroll_id: this.form.get(`krollId_${user.userId}`)?.value || null,
          };
          return acc;
        }, {});

      if (Object.keys(payload).length == 0) {
        this.toast.error('Please select at least one user');
        return;
      }
      const finalPayload = { users: payload };
      this.isLoading = true;
      this.krollService.updateOrderRxids(finalPayload).subscribe(res => {
        this.isLoading = false;
        if (res.body && res.body.success) {
          this.toast.success(res.body.message);
          this.dialogRef.close({ response: res.body });
        }
        else {
          this.disableButton = false;
          this.toast.error(res.body.message);
        }
      });
    }
  }

  closeModal() {
    this.dialogRef.close();
  }

}
